import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";

import { parseHTMLContent } from "../../function/shopping";

const MAX = 1;

const Introduce = ({ homepageInfo, url }) => {
  const navigate = useNavigate();
  const swiperRef = useRef(null);
  const [info, setInfo] = useState({ images: [], text: null });

  useEffect(() => {
    if (homepageInfo && homepageInfo.cmpnyIntroduce) {
      const cmpnyIntroduce = parseHTMLContent(homepageInfo.cmpnyIntroduce);
      setInfo({
        ...cmpnyIntroduce,
        images: cmpnyIntroduce?.images?.[0] || "/img/shopTheme/modern_main_bg_01.png",
      });
    } else {
      setInfo({ image: ["/img/shopTheme/modern_main_bg_01.png"] });
    }
  }, [homepageInfo]);

  const goToCmpny = () => {
    navigate(`/shop/${url}/company`);
  };

  return (
    <div className="introduce">
      <div className="inner" style={{ backgroundImage: `url(${info.images})` }}>
        <div className="company">
          <div className="bar"></div>
          {info.text ? (
            <span dangerouslySetInnerHTML={{ __html: info.text }} onClick={goToCmpny}></span>
          ) : (
            <span onClick={goToCmpny}>
              안녕하세요,
              <br />
              <strong>{homepageInfo?.cmpnyNm}</strong>입니다.
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Introduce;
